import { clearCreditsIntroSeen } from "@repo/shared/credits";
import { clearCachedEntitlement } from "@repo/shared/redux";

import { withMixpanel } from "../../../events/mixpanelClient";
import { clearSignupContext } from "../../../events/signupTracking";
import { clearDailyCreditTestGroup } from "../../../experiments/dailyCreditExperiment";
import { clearSignupBonusTestGroup } from "../../../experiments/signupBonusExperiment";
import {
  EXCLUDE_COMPLETED_EVOLUTIONS,
  EXCLUDE_PAID_EVOLUTIONS,
  SBC_PARAM_KEYS,
} from "../../../settings";
import axios from "../../privateApi";

export const logout = () => {
  return axios
    .post("/auth/logout")
    .then((_) => {
      endUserSession();
    })
    .catch((_) => {
      endUserSession();
    });
};

/**
 * Everything that must stop being true when a session ends.
 *
 * One function because a session ends two ways and both have to leave the same
 * browser behind: the logout button (via `logout` above) and the forced logout
 * on an expired or rejected token (api/interceptors →
 * removeUserAndRedirectToLogin). The forced path is the one users actually hit,
 * and anything wired only into the logout thunk is effectively never run.
 *
 * The analytics teardown belongs here rather than beside the thunk's other
 * dispatches for the same reason. Both of those keys are per-USER state that
 * outlives the account they describe: the A/B arm rides x-mp-test-groups into
 * the next account's requests and gets `$set_once` onto the wrong profile
 * (permanently — `$set_once` takes no second answer), and a signup context left
 * over from a logged-in club-import attributes the next signup on this browser
 * to a different person's session.
 */
export const endUserSession = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("name");
  localStorage.removeItem("email");
  clearCachedEntitlement();
  clearCreditsIntroSeen();
  localStorage.removeItem("loggedIn");
  localStorage.removeItem("uuid");
  localStorage.removeItem("platform");
  localStorage.removeItem("favoriteClubId");
  SBC_PARAM_KEYS.forEach((key) => localStorage.removeItem(key));
  localStorage.removeItem(EXCLUDE_PAID_EVOLUTIONS);
  localStorage.removeItem(EXCLUDE_COMPLETED_EVOLUTIONS);
  // Fresh anonymous distinct_id for whoever is next, rather than the previous
  // user's uuid.
  withMixpanel((mp) => mp.reset());
  clearDailyCreditTestGroup();
  clearSignupBonusTestGroup();
  clearSignupContext();
};
